import { useEffect } from 'react';

import { useQuery } from '@tanstack/react-query';

import { contactsApi } from '@/lib/api/contacts.api';
import { useActiveContactsStore } from '@/stores/active-contacts.store';

/**
 * Fetches the initial set of active contact IDs on mount and syncs them
 * into the Zustand store.  Real-time updates arrive via the messaging
 * WebSocket (handled in useMessagingSocket).
 *
 * Call this once high in the contacts page tree.
 */
export function useActiveContacts() {
  const setActiveSessions = useActiveContactsStore((s) => s.setActiveSessions);

  const { data } = useQuery({
    queryKey: ['contacts', 'active-sessions'],
    queryFn: () => contactsApi.getActiveSessions(),
    refetchInterval: 30_000,
  });

  useEffect(() => {
    if (data) {
      setActiveSessions(data);
    }
  }, [data, setActiveSessions]);
}
